//track clicks and add to cart events
(() => {
  setTimeout(()=>{
    const urlParams = new URLSearchParams(window.location.search);

    /////////////////////////////////////
    // Yow might also like
    /////////////////////////////////////

    const ymal = urlParams.get('ymal');
    if(ymal == 1){
      // console.log('record ymal click')
      gtag('event', 'you_may_also_like_click', {
        'product_url': window.location.pathname
      });

      document.getElementsByClassName('add-to-cart')[0].addEventListener('click', e => {
        // console.log('record ymal atc')
        gtag('event', 'you_may_also_like_atc', {
          'product_url': window.location.pathname
        });
      })
    }

    // add query param to product links
    let recList = document.getElementsByClassName("product-recommendations__list");
    if(recList.length > 0){
      Array.from(recList[0].getElementsByTagName('a')).forEach(
        el => {
          el.href += '?ymal=1';
        }
      )
    } 

    /////////////////////////////////////
    // Preview the Look
    /////////////////////////////////////
     
    const ptl = urlParams.get('ptl');
    if(ptl == 1 && window.location.pathname.includes('products')){
      // console.log('record ptl click')
      gtag('event', 'preview_the_look_click', {
        'product_url': window.location.pathname
      });

      if(document.getElementsByClassName('add-to-cart').length > 0){
        document.getElementsByClassName('add-to-cart')[0].addEventListener('click', e => {
          // console.log('record ptl atc')
          gtag('event', 'preview_the_look_atc', {
            'product_url': window.location.pathname
          });
        })
      }
    }

    // add query param to product links
    let productGridListArr = Array.from(document.getElementsByClassName('product-grid__products-list'));
    productGridListArr.forEach(list => {
      Array.from(list.getElementsByClassName('product-grid__product-link')).forEach(
        a => {
          a.href += '?ptl=1';
        }
      )
    })

    if(window.location.pathname.includes('/collections/')){
      let handle = window.location.pathname.split('/collections/')[1];
      //console.log('collections')
      //console.log(handle)

      /*
      Array.from(document.getElementsByClassName('boost-pfs-filter-option')).forEach(
        option => {

          let title = option.getElementsByClassName('boost-pfs-filter-option-title-text')[0].innerText;
          //console.log(title)
          //console.log('------------------')
          Array.from(option.getElementsByClassName('boost-pfs-filter-option-item')).forEach(
            item => {

              let value = item.getElementsByClassName('boost-pfs-filter-option-value')[0].innerText;
              //console.log(value)

              let btn = item.getElementsByClassName('boost-pfs-filter-button')[0];

              btn.addEventListener('click', e => {
                //console.log(btn.getAttribute('aria-checked'));
                if(!btn.getAttribute('aria-checked')){
                  console.log(`${value} filter activated`)
                  gtag('event', 'filter_activated', {
                    'collection_handle': handle,
                    'filter_option': title,
                    'filter_option_value': value
                  });
                } else {
                  console.log(`${value} filter deactivated`)
                  gtag('event', 'filter_deactivated', {
                    'collection_handle': handle,
                    'filter_option': title,
                    'filter_option_value': value
                  });

                }
              })
            }
          )
        }
      )
      */
    }
  }, 2000)
})();

// Track main nav clicks
(()=>{ 
  const navItems = Array.from(document.getElementsByClassName('nav-main')[0].getElementsByTagName('a'));
  navItems.forEach(a => {
    a.addEventListener('click', e => {
      gtag("event", "main_nav_click", {
        'link_title': a.innerText,
        'to': a.href.replace('https://fearofgod.com',''),
        'from': window.location.href.replace('https://fearofgod.com',''),
      }); 
    })
  })
})();


function facetAnalytics(e){
  //console.log('facetAnalytics', e);
  let handle = window.location.pathname.split('/collections/')[1];
  if(e.checked){
    //console.log(`${e.value} filter activated | handle: ${handle} title: ${e.dataset.filter}`)
    gtag('event', 'filter_activated', {
      'collection_handle': handle,
      'filter_option': e.dataset.filter,
      'filter_option_value': e.value
    });
  } else {
    //console.log(`${e.value} filter deactivated | handle: ${handle} title: ${e.dataset.filter}`)
    gtag('event', 'filter_deactivated', {
      'collection_handle': handle,
      'filter_option': e.dataset.filter,
      'filter_option_value': e.value
    });
  }
}

function sortAnalytics(e){
  //console.log('facetAnalytics', e);
  let handle = window.location.pathname.split('/collections/')[1];
  if(e.checked){
    // console.log(`${e.value} sort activated | handle: ${handle}`)
    gtag('event', 'sort_applied', {
      'collection_handle': handle,
      'sort_option': e.value,
    });
  }
}